// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../features/members/MemberItem.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Page - Tavern Theme */

.admin-page {
  /* background inherited from body wood texture */
}

.admin-page .ttbPageTitle {
  color: var(--color-fire-500);
  font-family: var(--font-heading);
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  border-bottom: 2px solid var(--color-fire-600);
  padding-bottom: var(--space-3);
  margin-bottom: var(--space-6);
}

/* Admin Stats */
.admin-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: var(--space-4);
  margin-bottom: var(--space-6);
}

.stat-card {
  background: var(--color-parchment-100);
  
  /* Parchment texture */
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),
    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);
  
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  text-align: center;
}

.stat-card-value {
  font-family: var(--font-heading);
  font-size: 32px;
  font-weight: 700;
  color: var(--color-fire-600);
}

.stat-card-label {
  font-size: 13px;
  color: var(--color-text-secondary);
  margin-top: var(--space-2);
}

/* User Cards */
.user-card {
  background: var(--color-parchment-100);
  
  /* Parchment texture */
  background-image: 
    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),
    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),
    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),
    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);
  
  border: 2px solid var(--color-wood-700);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  margin-bottom: var(--space-3);
  transition: all var(--transition-fast);
}

.user-card:hover {
  border-color: var(--color-fire-600);
  box-shadow: var(--shadow-md);
}

.user-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-3);
}

.user-info {
  display: flex;
  align-items: center;
  gap: var(--space-3);
}

.user-avatar {
  width: 48px;
  height: 48px;
  background: var(--color-wood-700);
  border: 2px solid var(--color-wood-700);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  position: relative;
}

.user-role-badge {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 20px;
  height: 20px;
  background: var(--color-wood-800);
  border: 2px solid var(--color-parchment-100);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.user-role-badge-admin {
  background: var(--color-fire-600);
}

.user-role-badge-organizer {
  background: var(--color-info-500);
}

.user-details {
  flex: 1;
}

.user-name {
  font-weight: 700;
  color: var(--color-text-primary);
  margin-bottom: 2px;
}

.user-role-text {
  font-size: 12px;
  color: var(--color-text-secondary);
}

/* Admin Users list — MemberItem style */

.admin-users-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.admin-user-item {
  display: flex;
  align-items: center;
  padding: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  border: 2px solid var(--color-wood-800);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);
  transition: all 0.2s ease;
  overflow: visible;
}

.admin-user-item:hover {
  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.45);
}

.admin-user-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.admin-user-name {
  font-weight: 600;
  font-size: 15px;
  color: var(--color-fire-600);
  text-decoration: none;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

.admin-user-name:hover {
  text-decoration: underline;
}

.admin-user-role-text {
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-secondary);
}

@media (max-width: 425px) {
  .admin-user-item {
    border-width: 1px;
    border-radius: 10px;
  }
}

@media (min-width: 768px) {
  .admin-users-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Admin/AdminPage.css"],"names":[],"mappings":"AAEA,8BAA8B;;AAE9B;EACE,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,2CAA2C;EAC3C,8CAA8C;EAC9C,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;;EAEtC,sBAAsB;EACtB;;;;;kIAKgI;;EAEhI,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,sCAAsC;;EAEtC,sBAAsB;EACtB;;;;;kIAKgI;;EAEhI,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA,wCAAwC;;AAGxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,6DAA6D;EAC7D,uCAAuC;EACvC,6CAA6C;EAC7C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,kBAAkB;EACpB;AACF","sourcesContent":["@import '../_base.css';\n\n/* Admin Page - Tavern Theme */\n\n.admin-page {\n  /* background inherited from body wood texture */\n}\n\n.admin-page .ttbPageTitle {\n  color: var(--color-fire-500);\n  font-family: var(--font-heading);\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);\n  border-bottom: 2px solid var(--color-fire-600);\n  padding-bottom: var(--space-3);\n  margin-bottom: var(--space-6);\n}\n\n/* Admin Stats */\n.admin-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: var(--space-4);\n  margin-bottom: var(--space-6);\n}\n\n.stat-card {\n  background: var(--color-parchment-100);\n  \n  /* Parchment texture */\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),\n    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);\n  \n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  text-align: center;\n}\n\n.stat-card-value {\n  font-family: var(--font-heading);\n  font-size: 32px;\n  font-weight: 700;\n  color: var(--color-fire-600);\n}\n\n.stat-card-label {\n  font-size: 13px;\n  color: var(--color-text-secondary);\n  margin-top: var(--space-2);\n}\n\n/* User Cards */\n.user-card {\n  background: var(--color-parchment-100);\n  \n  /* Parchment texture */\n  background-image: \n    radial-gradient(circle at 20% 30%, rgba(139, 69, 19, 0.12) 0%, transparent 50%),\n    radial-gradient(circle at 80% 70%, rgba(160, 82, 45, 0.08) 0%, transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(210, 180, 140, 0.15) 0%, transparent 80%),\n    repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(139, 69, 19, 0.06) 2px, rgba(139, 69, 19, 0.06) 3px),\n    repeating-linear-gradient(90deg, transparent, transparent 100px, rgba(160, 82, 45, 0.03) 100px, rgba(160, 82, 45, 0.03) 101px);\n  \n  border: 2px solid var(--color-wood-700);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  margin-bottom: var(--space-3);\n  transition: all var(--transition-fast);\n}\n\n.user-card:hover {\n  border-color: var(--color-fire-600);\n  box-shadow: var(--shadow-md);\n}\n\n.user-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-3);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n}\n\n.user-avatar {\n  width: 48px;\n  height: 48px;\n  background: var(--color-wood-700);\n  border: 2px solid var(--color-wood-700);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  position: relative;\n}\n\n.user-role-badge {\n  position: absolute;\n  bottom: -2px;\n  right: -2px;\n  width: 20px;\n  height: 20px;\n  background: var(--color-wood-800);\n  border: 2px solid var(--color-parchment-100);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n}\n\n.user-role-badge-admin {\n  background: var(--color-fire-600);\n}\n\n.user-role-badge-organizer {\n  background: var(--color-info-500);\n}\n\n.user-details {\n  flex: 1;\n}\n\n.user-name {\n  font-weight: 700;\n  color: var(--color-text-primary);\n  margin-bottom: 2px;\n}\n\n.user-role-text {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n}\n\n/* Admin Users list — MemberItem style */\n@import '../../features/members/MemberItem.css';\n\n.admin-users-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.admin-user-item {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  border: 2px solid var(--color-wood-800);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);\n  transition: all 0.2s ease;\n  overflow: visible;\n}\n\n.admin-user-item:hover {\n  box-shadow: 0 4px 12px rgba(109, 76, 41, 0.45);\n}\n\n.admin-user-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.admin-user-name {\n  font-weight: 600;\n  font-size: 15px;\n  color: var(--color-fire-600);\n  text-decoration: none;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n}\n\n.admin-user-name:hover {\n  text-decoration: underline;\n}\n\n.admin-user-role-text {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n}\n\n@media (max-width: 425px) {\n  .admin-user-item {\n    border-width: 1px;\n    border-radius: 10px;\n  }\n}\n\n@media (min-width: 768px) {\n  .admin-users-list {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    align-items: start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
